(function ltOriginBootstrap(window) {
  'use strict';

  var VERSION = '1.0.0';
  var SCHEMA = 'lt-attribution-v1';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var STORAGE_FIRST = 'jb.lt.first.v1';
  var STORAGE_LAST = 'jb.lt.last.v1';
  var MAX_TOKEN_LENGTH = 80;
  var MAX_CODE_LENGTH = 30;
  var DIRECT_VALUES = {
    direct: true,
    '(direct)': true,
    none: true,
    '(none)': true,
    unknown: true,
    desconocido: true,
    'not-set': true,
    '(not-set)': true
  };

  var memoryStorage = Object.create(null);
  var state = {
    first: null,
    last: null,
    lastSync: { status: 'idle', at: null, error: null },
    syncPromise: null
  };

  function nowMs() {
    return Date.now();
  }

  function nowIso() {
    return new Date(nowMs()).toISOString();
  }

  function clone(value) {
    return value == null ? value : JSON.parse(JSON.stringify(value));
  }

  function storageGet(key) {
    try {
      var stored = window.localStorage.getItem(key);
      if (stored != null) return stored;
      return Object.prototype.hasOwnProperty.call(memoryStorage, key)
        ? memoryStorage[key]
        : null;
    } catch (_error) {
      return Object.prototype.hasOwnProperty.call(memoryStorage, key)
        ? memoryStorage[key]
        : null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      delete memoryStorage[key];
    } catch (_error) {
      memoryStorage[key] = value;
    }
  }

  function storageRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (_error) {
      delete memoryStorage[key];
    }
  }

  function stripDiacritics(value) {
    try {
      return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (_error) {
      return value;
    }
  }

  function looksLikePii(value) {
    if (!value) return false;
    var text = String(value).trim();
    if (!text) return false;
    if (/@/.test(text)) return true;
    if (/^(?:mailto|tel):/i.test(text)) return true;

    var digits = text.replace(/\D/g, '');
    if (digits.length >= 7) return true;
    return false;
  }

  function normalizeToken(value, maxLength) {
    if (value == null) return null;
    var text = String(value).trim();
    if (!text || looksLikePii(text)) return null;

    text = stripDiacritics(text)
      .toLowerCase()
      .replace(/[^a-z0-9._-]+/g, '-')
      .replace(/-{2,}/g, '-')
      .replace(/^[._-]+|[._-]+$/g, '');

    if (!text || looksLikePii(text)) return null;
    return text.slice(0, maxLength || MAX_TOKEN_LENGTH);
  }

  function normalizeCode(value) {
    var token = normalizeToken(value, MAX_CODE_LENGTH);
    if (!token) return null;
    token = token
      .replace(/[._]+/g, '-')
      .replace(/-{2,}/g, '-')
      .replace(/^-+|-+$/g, '');
    return token ? token.slice(0, MAX_CODE_LENGTH) : null;
  }

  function normalizeIso(value, fallback) {
    if (!value) return fallback;
    var parsed = Date.parse(String(value));
    return Number.isFinite(parsed) ? new Date(parsed).toISOString() : fallback;
  }

  function compactTouch(touch) {
    if (!touch) return null;
    var output = {
      source: normalizeToken(touch.source, MAX_TOKEN_LENGTH),
      medium: normalizeToken(touch.medium, MAX_TOKEN_LENGTH),
      campaign: normalizeToken(touch.campaign, MAX_TOKEN_LENGTH),
      content: normalizeToken(touch.content, MAX_TOKEN_LENGTH),
      term: normalizeToken(touch.term, MAX_TOKEN_LENGTH),
      code: normalizeCode(touch.code),
      at: normalizeIso(touch.at, nowIso())
    };

    if (
      !output.source &&
      !output.medium &&
      !output.campaign &&
      !output.content &&
      !output.term &&
      !output.code
    ) {
      return null;
    }
    return output;
  }

  function isDirectValue(value) {
    return Boolean(value && DIRECT_VALUES[String(value).toLowerCase()]);
  }

  function isNonDirectTouch(touch) {
    if (!touch) return false;

    // A canonical code, campaign or content is positive attribution evidence even
    // when an old link labels the source generically as direct.
    if (touch.code || touch.campaign || touch.content || touch.term) return true;

    if (touch.source && !isDirectValue(touch.source)) return true;
    if (touch.medium && !isDirectValue(touch.medium)) return true;
    return false;
  }

  function readEnvelope(key) {
    var raw = storageGet(key);
    if (!raw) return null;

    try {
      var envelope = JSON.parse(raw);
      if (
        !envelope ||
        envelope.schema !== SCHEMA ||
        !Number.isFinite(envelope.expiresAt) ||
        envelope.expiresAt <= nowMs()
      ) {
        storageRemove(key);
        return null;
      }
      var touch = compactTouch(envelope.touch);
      if (!isNonDirectTouch(touch)) {
        storageRemove(key);
        return null;
      }
      return touch;
    } catch (_error) {
      storageRemove(key);
      return null;
    }
  }

  function writeEnvelope(key, touch) {
    storageSet(
      key,
      JSON.stringify({
        schema: SCHEMA,
        expiresAt: nowMs() + TTL_MS,
        touch: touch
      })
    );
  }

  function queryParams() {
    return new URLSearchParams(window.location.search || '');
  }

  function touchFromQuery(params, prefix) {
    var pre = prefix || '';
    var fallbackAt = nowIso();
    var content = normalizeToken(params.get(pre + 'utm_content'), MAX_TOKEN_LENGTH);
    var code = normalizeCode(
      params.get(pre + 'traffic_code') ||
      params.get(pre + 'code') ||
      content
    );

    return compactTouch({
      source: params.get(pre + 'utm_source'),
      medium: params.get(pre + 'utm_medium'),
      campaign: params.get(pre + 'utm_campaign'),
      content: content,
      term: params.get(pre + 'utm_term'),
      code: code,
      at: params.get(pre + 'at') || fallbackAt
    });
  }

  function transferredFirstFromQuery(params) {
    var fallbackAt = nowIso();
    return compactTouch({
      source: params.get('ft_source') || params.get('ft_utm_source'),
      medium: params.get('ft_medium') || params.get('ft_utm_medium'),
      campaign: params.get('ft_campaign') || params.get('ft_utm_campaign'),
      content: params.get('ft_content') || params.get('ft_utm_content'),
      term: params.get('ft_term') || params.get('ft_utm_term'),
      code:
        params.get('ft_code') ||
        params.get('ft_traffic_code') ||
        params.get('ft_content') ||
        params.get('ft_utm_content'),
      at: params.get('ft_at') || fallbackAt
    });
  }

  function capture() {
    var params = queryParams();
    var storedFirst = readEnvelope(STORAGE_FIRST);
    var storedLast = readEnvelope(STORAGE_LAST);
    var transferredFirst = transferredFirstFromQuery(params);
    var current = touchFromQuery(params, '');

    if (!isNonDirectTouch(transferredFirst)) transferredFirst = null;
    if (!isNonDirectTouch(current)) current = null;

    // First touch is immutable until its 90-day envelope expires.
    state.first = storedFirst || transferredFirst || current || null;
    if (!storedFirst && state.first) writeEnvelope(STORAGE_FIRST, state.first);

    // Direct or untagged visits never erase a known last non-direct touch.
    state.last = current || storedLast || transferredFirst || state.first || null;
    if (current) {
      writeEnvelope(STORAGE_LAST, current);
    } else if (!storedLast && state.last) {
      writeEnvelope(STORAGE_LAST, state.last);
    }

    return getState();
  }

  function attributeValue(value) {
    return value == null ? '' : String(value).slice(0, MAX_TOKEN_LENGTH);
  }

  function cartAttributes() {
    if (!state.first && !state.last) return {};

    var attributes = { __lt_schema: SCHEMA };
    ['first', 'last'].forEach(function (kind) {
      var touch = state[kind];
      if (!touch) return;
      attributes['__lt_' + kind + '_source'] = attributeValue(touch.source);
      attributes['__lt_' + kind + '_medium'] = attributeValue(touch.medium);
      attributes['__lt_' + kind + '_campaign'] = attributeValue(touch.campaign);
      attributes['__lt_' + kind + '_content'] = attributeValue(touch.content);
      attributes['__lt_' + kind + '_term'] = attributeValue(touch.term);
      attributes['__lt_' + kind + '_code'] = attributeValue(touch.code);
      attributes['__lt_' + kind + '_at'] = attributeValue(touch.at);
    });
    return attributes;
  }

  function cartUpdateUrl() {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';
    if (!root.endsWith('/')) root += '/';
    return root + 'cart/update.js';
  }

  function sync() {
    var attributes = cartAttributes();
    if (!Object.keys(attributes).length) {
      state.lastSync = { status: 'skipped', at: nowIso(), error: null };
      return Promise.resolve(getState());
    }

    state.lastSync = { status: 'pending', at: nowIso(), error: null };
    state.syncPromise = window
      .fetch(cartUpdateUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      })
      .then(function (response) {
        if (!response || !response.ok) {
          throw new Error('cart_update_failed');
        }
        state.lastSync = { status: 'ok', at: nowIso(), error: null };
        return getState();
      })
      .catch(function (error) {
        state.lastSync = {
          status: 'error',
          at: nowIso(),
          error: error && error.message ? String(error.message) : 'cart_update_failed'
        };
        return getState();
      });

    return state.syncPromise;
  }

  function getState() {
    return clone({
      version: VERSION,
      schema: SCHEMA,
      ttlDays: 90,
      first: state.first,
      last: state.last,
      cartAttributes: cartAttributes(),
      lastSync: state.lastSync
    });
  }

  function refresh() {
    capture();
    return sync();
  }

  capture();
  var ready = sync();

  // Public, read-only QA surface. It deliberately exposes sanitized state rather
  // than storage keys or raw browser data.
  window.__ltAttribution = Object.freeze({
    version: VERSION,
    ready: ready,
    getState: getState,
    sync: sync,
    refresh: refresh
  });
})(window);
